import React from 'react'
import PropTypes from 'prop-types'

export default class CarePlanSortType extends React.Component {
  state = {
    changedSort: undefined,
  }

  handleChange = (e) => {
    const { onChange } = this.props
    const type = e.target.value
    this.setState({ changedSort: type })
    onChange(null)
    onChange(type)
  }

  render() {
    const { sortType, style } = this.props
    return (
      <select
        className="lmc-handover-select"
        style={{ ...style, ...styles.select }}
        value={sortType || this.state.changedSort}
        onChange={this.handleChange}
      >
        <option value="a-z">A-Z</option>
        <option value="last-review-date">Last review date</option>
        <option value="next-review-date">Next review date</option>
      </select>
    )
  }
}

const styles = {
  select: {
    border: 'none',
    background: 'inherit',
    cursor: 'pointer',
    fontWeight: 600,
    textAlign: 'right',
    width: 160,
  },
}

CarePlanSortType.propTypes = {
  onChange: PropTypes.func.isRequired,
  sortType: PropTypes.string,
  style: PropTypes.object,
}
